// Funcion que convierte y retorna la ruta para el estado del componente <BreadCrumbsGeneric /> ,
// y saber en que ruta estas para el manejo de la  navegacion

export const path = (full) => {


  var res = full?.replace(/[^a-zA-Z]+/g, "");

  switch (res) {
    case "cuentaserviciodetelevision":
      return [{ name: "Servicios Televisión", href: full }];
    case "cuentaserviciodetelevisiondetalletelevision":
      return [
        { name: "Servicios Televisión", href: "/cuenta/servicio-de-television" },
        { name: "Detalle", href: full },
      ];
    case "cuentaserviciodeinternet":
      return [{ name: "Servicios Internet", href: full }];
    case "cuentaserviciodeinternetdetalleinternet":
      return [
        { name: "Servicios Internet", href: "/cuenta/servicio-de-internet" },
        { name: "Detalle", href: full },
      ];
    case "cuentaserviciodesaludintegral":
      return [
        { name: "Servicios Salud Integral", href: "/cuenta/servicio-de-salud-integral" },
      ];   
    case "cuentaserviciodesaludintegraldetallesaludintegral":
      return [
        { name: "Servicios Salud Integral", href: "/cuenta/servicio-de-salud-integral" },
        { name: "Detalle", href: full },
      ];            
    case "cuentaserviciodedatos":
      return [{ name: "Servicios Datos", href: full }];
    case "cuentaserviciodedatosdetalledatos":
      return [
        { name: "Servicios Datos", href: "/cuenta/servicio-de-datos/detalle-datos" },
        { name: "Detalle", href: full },
      ];
    case "cuentaserviciodetelefonia":
      return [{ name: "Servicios Telefonía", href: full }];
    case "cuentaserviciodetelefoniadetalletelefonia":
      return [
        { name: "Servicios Telefonía", href: "/cuenta/servicio-de-telefonia" },
        { name: "Detalle", href: full },
      ];
    case "cuentaserviciodestreaming":
      return [{ name: "Servicios Televisión Streaming", href: full }];
    case "cuentaserviciodestreamingdetallestreaming":
      return [
        { name: "Servicios Televisión Streaming", href: "/cuenta/servicio-de-streaming" },
        { name: "Detalle", href: full },
      ];
    case "cuentasaldo":
      return [{ name: "Saldo", href: "/cuenta/saldo" }];

    case "cuentapagos":
      return [
        { name: "Pagos", href: "/cuenta/pagos" },
        
      ];
    case "cuentaverfacturas":
      return [{ name: "Ver Facturas", href: "/cuenta/ver-facturas" }];
    case "cuentafacturasestadodecuenta":
      return [
        { name: "Ver Facturas", href: "/cuenta/ver-facturas" },
        { name: "Estado de cuenta", href: full },
      ];
    case "cuentapagosestadodecuenta":
      return [
        { name: "Ver Facturas", href: "/cuenta/ver-facturas" },
        { name: "Estado de cuenta", href: full },
      ];
    case "cuentaverreportes":
      return [{ name: "Reportes", href: full }];

    case "cuentaconsultas":
      return [{ name: "Consultas", href: full }];

    case "cuentanotificacionretenciones":
      return [{ name: "Notificaciones y Retenciones", href: "/cuenta/notificacion-retenciones" }];

    case "cuentadomiciliaciontipodomiciliacion":
      return [{ name: "Domiciliación", href: full }];

    case "cuentadomiciliaciontipoinstrumento":
      return [
        { name: "Domiciliación", href: "/cuenta/saldo" },
        { name: "Detalle", href: full },
      ];
    case "cuentadomiciliaciondomiciliaciondebito":
      case "cuentadomiciliaciondomiciliacioncredito":
      return [{ name: "Domiciliación", href: "/cuenta/saldo" }];

    case "cuentanotificacionretenciones":
      return [{ name: "Notificaciones y Retenciones", href: "/cuenta/notificacion-retenciones" }];

    

    default:
      break;
  }
};
